import * as React from "react";
import { useTranslation } from "react-i18next";
import { AudioEnum } from "../../../../enums";
import { getAudio } from "../../../../utils/AudioUtils";
import { getStakeColorAndClass } from "../../../../utils/NumberDetails";
import AudioPlayerNonInteractiveEffect from "../../AudioPlayer/AudioEffect/AudioPlayerNonInteractiveEffect";

interface Props {
  winAmount: number;
  winningNumber: number;
}

const BetWon: React.FC<Props> = ({ winAmount, winningNumber }) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="info_box small">
        <div className="title">{t("panel.common.win")}</div>
        <div className="box">{winAmount / 100}</div>
      </div>

      <div className="info_box small draw">
        <div className="title">{t("panel.drawingPanel.drawnNumber")}</div>
        <div className="box">
          <div
            className={`ball ${getStakeColorAndClass(
              winningNumber.toString()
            )}`}
          >
            {winningNumber}
          </div>
        </div>
      </div>

      <AudioPlayerNonInteractiveEffect
        audioEffectToBePlayed={getAudio(AudioEnum.EFFECT_BET_WON)}
      />
    </>
  );
};

export default BetWon;
